import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function fileTypeValidator(allowedTypes: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const file = control.value;

    if (!file) {
      return null;
    }

    if (file instanceof File) {
      if (!allowedTypes.includes(file.type)) {
        return { fileType: { allowed: allowedTypes, actual: file.type } };
      }
    } else {
      return { invalidFile: true };
    }

    return null;
  };
}
